import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { createBrowserRouter, RouterProvider } from 'react-router-dom';

import { LandingPage, FloorPlansPage, VisualizerPage, SharedPage } from './components/features';
import { ChamUpload, ChamProjects } from './components/shared';
import { getAllSheetsFromFile } from './Helpers/SheetsHelper';
import { setFloorplansData, setLoading, setError } from './store/floorplanSlice';


const router = createBrowserRouter([
  { path: '/', element: <><LandingPage /> <ChamProjects /></>, errorElement: <h1>ERROR</h1> },
  { path: '/floorplans', element: <><FloorPlansPage /> <ChamProjects /></> },
  { path: '/visualizer/:floorplanId', element: <><VisualizerPage /> <ChamProjects /></> },
  { path: '/shared/:code', element: <SharedPage /> },
])


function App() {
  const dispatch = useDispatch();

  useEffect(() => {
    const loadFloorplanData = async () => {
      dispatch(setLoading(true));
      try {
        console.log('Loading floorplan data from /data/Floorplans.xlsx...');
        const data = await getAllSheetsFromFile('/data/Floorplans.xlsx');
        console.log('Sheet names:', Object.keys(data || {}));
        console.log('Floorplans count:', data?.Floorplans?.length || 0);
        console.log('Rooms count:', data?.Rooms?.length || 0);
        console.log('Steps count:', data?.Steps?.length || 0);
        dispatch(setFloorplansData(data));
      } catch (error) {
        console.error('Error loading floorplan data:', error);
        dispatch(setError(error.message));
      }
    };

    loadFloorplanData();
  }, [dispatch]);

  return (
    <>
      <RouterProvider router={router} />
      {/* ChamUpload renders the web component needed for ChamUploadButton */}
      <ChamUpload />
    </>
  );
}

export default App;
